export const USER_ALREADY_REGISTERED = 'user.alreadyRegistered.error'
